import React from 'react'
import { CSpinner } from '@coreui/react-pro'

export const Spinner = ({ message = '', ...rest }) => {
  const { pageLoading } = rest
  const { children } = rest

  return (
    <>
      {pageLoading === false ? (
        children
      ) : (
        <div className='spinner--wrapper'>
          <div className='d-flex flex-column align-items-center justify-content-center'>
            <CSpinner color='primary' variant='grow' />
            <h6 className='mt-2'>{message}</h6>
          </div>
        </div>
      )}
    </>
  )
}
